import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = {
  class: "d-flex flex-column bgi-no-repeat rounded-top",
  style: {"background-image":"url('/media/misc/pattern-1.jpg')"}
}
const _hoisted_3 = { class: "text-white fw-bold px-9 mt-5 mb-5" }
const _hoisted_4 = { class: "scroll-y mh-325px my-5 px-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "symbol symbol-35px me-4" }
const _hoisted_8 = {
  key: 0,
  class: "bg-light-success symbol-label"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-message-notif" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "bg-light-info symbol-label"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-message-text" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "bg-light-danger symbol-label"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ki-outline ki-notification" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "mb-0 me-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "badge badge-circle badge-primary",
  style: {"width":"8px","height":"8px","min-width":"8px","padding":"0"}
}
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "py-3 text-center border-top" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-book-open fs-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.top_bar.notifications`)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          onClick: ($event: any) => (_ctx.MarkAsRead(item)),
          class: "d-flex flex-stack py-4 px-4 mb-3",
          style: _normalizeStyle(item.is_read ? '' : 'cursor: pointer; border-radius: 15px; background-color: rgba(0, 0, 0, 0.1);')
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (item.type == 'mention')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              (item.type == 'comment')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              (item.type != 'comment' && item.type != 'mention')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: { name: 'feed-view', params: { id: item.notifiable?.id } },
                class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _hoisted_18,
              _createElementVNode("small", {
                class: "text-gray-600",
                title: item?.created_at
              }, _toDisplayString(_ctx.moment(item?.created_at).fromNow()), 9, _hoisted_19),
              _hoisted_20,
              _createElementVNode("div", {
                class: _normalizeClass(item?.is_read ? 'text-gray-400 fs-7' : 'text-gray-800 fs-7 fw-bold')
              }, _toDisplayString(item.body), 3)
            ])
          ]),
          (!item.is_read)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21))
            : _createCommentVNode("", true)
        ], 12, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.MarkAllAsRead())),
          class: "btn btn-color-gray-600 btn-active-color-primary"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.top_bar.mark_everything_read`)) + " ", 1),
          _hoisted_24
        ])
      ])
    ])
  ]))
}